export const translations = {
  fr: {
    nav: {
      experiences: "Expériences",
      boho: "The Boho Picnic",
      floating: "Floating Picnic",
      electronic: "Picnic Electronic",
      privateEvents: "Événements Privés",
      gallery: "Galerie",
      about: "À propos",
      faq: "FAQ",
      contact: "Contact",
      book: "Réserver",
    },
    hero: {
      overline: "Nice — Côte d'Azur",
      title: "Des pique-niques d'exception sur la Côte d'Azur",
      subtitle: "Des expériences de pique-nique sur mesure, des spots secrets et des moments inoubliables entre Nice et la Méditerranée.",
      ctaBook: "Réserver votre pique-nique",
      ctaDiscover: "Découvrir nos expériences",
    },
    intro: {
      overline: "The Nice Picnic",
      title: "Plus qu'un pique-nique. Un moment dont on se souvient.",
      p1: "The Nice Picnic compose des moments d'exception sur la Côte d'Azur : une table dressée au bord de l'eau, des spécialités niçoises choisies avec soin, une décoration bohème, de la musique et des lieux confidentiels sélectionnés pour leur beauté.",
      p2: "Chaque expérience est personnalisée selon vos envies — un anniversaire, une demande en mariage, un coucher de soleil à deux ou une célébration entre amis.",
      signature: "The Nice Picnic — Côte d'Azur",
    },
    experiences: {
      overline: "Nos expériences",
      title: "Trois façons de vivre la Riviera",
      from: "À partir de",
      perPerson: "par personne",
      discover: "Découvrir",
      seeEvents: "Voir les événements",
      bohoTag: "L'expérience signature",
      bohoDesc: "Un pique-nique bohème chic dressé dans un spot secret : tapis, coussins, guirlandes de jute, spécialités niçoises et vin, face à la Méditerranée.",
      floatingTag: "Sur l'eau",
      floatingDesc: "Un pique-nique flottant à 50 mètres du rivage, au Port de la Darse à Villefranche-sur-Mer. Baignade, masque et tuba, vin et soleil.",
      electronicTag: "Événements au coucher du soleil",
      electronicDesc: "Un pique-nique collectif premium : DJ set organic & deep house dans un spot secret de la Côte d'Azur, au rythme du coucher de soleil.",
      onRequest: "Dates & tarifs par événement",
    },
    riviera: {
      overline: "Nos spots secrets",
      title: "De Nice à la Côte d'Azur",
      p1: "Des criques confidentielles aux collines qui dominent la baie des Anges, nous sélectionnons des lieux secrets entre Nice et la Côte d'Azur pour chaque expérience.",
      p2: "L'adresse exacte de votre spot vous est révélée après votre réservation — c'est ce qui rend chaque moment unique.",
    },
    lifestyle: {
      overline: "L'art de vivre",
      title: "La Méditerranée, à table",
      p: "Des produits du terroir niçois, une décoration bohème composée avec soin, la lumière dorée de la Riviera — chaque détail raconte une histoire.",
    },
    private: {
      overline: "Sur mesure",
      title: "Vos événements privés",
      p: "Anniversaires, demandes en mariage, moments romantiques, célébrations privées, événements d'entreprise ou expériences entièrement sur mesure — nous créons le moment qui vous ressemble.",
      cta: "Créez votre expérience",
      categories: ["Anniversaire", "Demande en mariage", "Moment romantique", "Célébration privée", "Événement d'entreprise", "Sur mesure"],
    },
    testimonials: {
      overline: "Ils ont vécu l'expérience",
      title: "Des souvenirs qui restent",
    },
    instagram: {
      overline: "@the.nicepicnic",
      title: "Suivez l'expérience",
      cta: "Suivre sur Instagram",
    },
    finalCta: {
      title: "Votre moment. À votre image.",
      cta: "Réserver votre pique-nique",
    },
    footer: {
      tagline: "Pique-niques d'exception — Nice, Côte d'Azur",
      navigation: "Navigation",
      contact: "Contact",
      follow: "Suivez-nous",
      privacy: "Politique de confidentialité",
      terms: "Conditions générales",
      cookies: "Cookies",
      rights: "© 2026 The Nice Picnic — Côte d'Azur. Tous droits réservés.",
    },
    boho: {
      overline: "2 heures — Spots secrets entre Nice et la Côte d'Azur",
      title: "The Boho Picnic",
      intro: "Notre expérience signature. Une installation bohème chic dressée pour vous dans un lieu secret : tapis, coussins, guirlandes de jute, attrape-rêves et une table généreuse de spécialités niçoises, face à la Méditerranée.",
      packages: "Nos formules",
      medium: "Formule Medium",
      premium: "Formule Premium",
      perPerson: "par personne",
      duration: "Durée : 2 heures",
      times: "Horaires de réservation",
      timesNote: "Départs à 11h00, 12h00, 13h00, 18h00 et 19h00 — chaque jour, selon disponibilité.",
      mediumIncludes: ["Installation pique-nique au sol", "Tapis & coussins", "Décoration bohème", "Guirlandes de jute", "Décoration attrape-rêves", "Enceinte Bluetooth", "Spécialités niçoises", "Une bouteille de vin pour deux invités", "Eau plate & eau pétillante"],
      premiumIncludes: ["Tout le contenu de la formule Medium", "Décoration premium élaborée", "Lanternes marocaines & éléments décoratifs supplémentaires", "Mise en scène raffinée", "Mini imprimante photo", "Enceinte Bluetooth"],
      bookCta: "Réserver The Boho Picnic",
      makeItYours: "À vous de jouer.",
      customP: "Chaque Boho Picnic peut être personnalisé selon vos envies : cuisine, décoration, lieu, occasion spéciale ou tout autre détail. Dites-nous ce que vous imaginez — nous le créons.",
      customItems: ["Cuisine & préférences alimentaires", "Décoration & ambiance", "Lieu", "Occasions spéciales", "Tout autre détail"],
      customCta: "Envoyer une demande de personnalisation",
      formTitle: "Personnalisez votre pique-nique",
    },
    floating: {
      overline: "1h30 — Port de la Darse, Villefranche-sur-Mer",
      title: "Floating Picnic",
      intro: "Une expérience unique sur l'eau : votre pique-nique est installé sur une structure flottante à environ 50 mètres du rivage, dans l'écrin du Port de la Darse. Restez à bord, plongez, nagez — la Méditerranée vous appartient.",
      priceNote: "89 € par personne — 2 personnes maximum par réservation.",
      exclusiveNote: "Une seule réservation par créneau : l'expérience est entièrement privée.",
      slotsTitle: "Créneaux quotidiens",
      includesTitle: "L'expérience comprend",
      includes: ["Installation pique-nique complète", "Spécialités niçoises", "Vin", "Eau plate & eau pétillante", "Enceinte Bluetooth", "Chapeaux", "Crème solaire", "Masques & tubas", "Baignade & expérience sur l'eau"],
      bookCta: "Réserver le Floating Picnic",
    },
    electronic: {
      overline: "Événements — Spots secrets de la Côte d'Azur",
      title: "Picnic Electronic",
      intro: "Un pique-nique collectif premium au coucher du soleil. Installation bohème, spot secret, DJ set organic & deep house et une ambiance immersive face à la Méditerranée.",
      upcoming: "Prochains événements",
      places: "places",
      placesLeft: "places restantes",
      soldOut: "Complet",
      bookSpot: "Réserver votre place",
      bookingClosed: "Réservations fermées",
      empty: "De nouvelles dates arrivent bientôt. Suivez @the.nicepicnic pour être les premiers informés.",
      from: "à partir de",
    },
    privatePage: {
      overline: "Événements privés",
      title: "Créons le moment qui vous ressemble",
      intro: "Une demande en mariage au coucher du soleil, un anniversaire les pieds dans le sable, un événement d'entreprise confidentiel — racontez-nous votre projet, nous composons l'expérience.",
      formTitle: "Parlez-nous de votre projet",
      name: "Nom",
      email: "Email",
      phone: "Téléphone",
      date: "Date souhaitée",
      guests: "Nombre d'invités",
      eventType: "Type d'événement",
      location: "Lieu souhaité",
      budget: "Budget",
      food: "Préférences alimentaires",
      decoration: "Préférences de décoration",
      message: "Votre message",
      submit: "Créer votre expérience",
      success: "Merci ! Votre demande a bien été envoyée. Nous revenons vers vous très vite.",
      types: ["Anniversaire", "Demande en mariage", "Expérience romantique", "Célébration privée", "Événement d'entreprise", "Influenceur / marque", "Sur mesure"],
    },
    gallery: {
      overline: "Galerie",
      title: "L'expérience en images",
    },
    about: {
      overline: "À propos",
      title: "The Nice Picnic, Côte d'Azur",
      p1: "Née à Nice, The Nice Picnic est une maison d'expériences dédiée à l'art du pique-nique sur la Côte d'Azur. Nous croyons qu'un repas peut devenir un souvenir — quand le lieu, la lumière, la table et les détails sont pensés ensemble.",
      p2: "Notre équipe sélectionne des spots secrets entre Nice et la Méditerranée, compose des décors bohèmes avec des matériaux naturels, et travaille avec les meilleurs artisans du terroir niçois.",
      p3: "Chaque expérience est unique, chaque détail est personnalisable. C'est notre définition du luxe : un moment qui ne ressemble qu'à vous.",
      values: ["Lieux secrets sélectionnés", "Produits du terroir niçois", "Décoration bohème artisanale", "Personnalisation complète"],
    },
    faq: {
      overline: "Questions fréquentes",
      title: "Tout savoir sur nos expériences",
      items: [
        { q: "Où se déroulent les pique-niques ?", a: "Dans des spots secrets sélectionnés entre Nice et la Côte d'Azur. L'adresse exacte vous est communiquée après confirmation de votre réservation." },
        { q: "Comment se passe le paiement ?", a: "Les réservations se règlent intégralement en ligne par carte bancaire, Apple Pay ou Google Pay via notre plateforme de paiement sécurisée." },
        { q: "Puis-je personnaliser mon expérience ?", a: "Absolument. Cuisine, décoration, lieu, occasion spéciale — chaque détail peut être adapté à vos envies. Indiquez vos souhaits lors de la réservation ou contactez-nous." },
        { q: "Que se passe-t-il en cas de mauvais temps ?", a: "En cas de conditions météorologiques défavorables, nous vous proposons de reporter votre expérience à une date ultérieure." },
        { q: "Combien de personnes peuvent participer ?", a: "The Boho Picnic accueille les groupes de toutes tailles. Le Floating Picnic est une expérience privée pour 2 personnes maximum. Picnic Electronic est un événement collectif avec un nombre de places limité." },
        { q: "Proposez-vous des options végétariennes ou sans gluten ?", a: "Oui. Indiquez simplement vos préférences et restrictions alimentaires lors de la réservation — nos menus sont adaptés avec le même soin." },
        { q: "Comment offrir une expérience ?", a: "Contactez-nous par WhatsApp ou via le formulaire de contact : nous préparons une carte cadeau élégante pour votre expérience à offrir." },
        { q: "Organisez-vous des événements privés ?", a: "Oui : anniversaires, demandes en mariage, célébrations, événements d'entreprise. Rendez-vous sur la page Événements Privés pour nous parler de votre projet." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Parlons de votre moment",
      p: "Une question, une envie particulière, un projet sur mesure ? Écrivez-nous — nous répondons très vite.",
      formName: "Nom",
      formEmail: "Email",
      formMessage: "Message",
      send: "Envoyer",
      success: "Message envoyé ! Nous vous répondrons très vite.",
      whatsapp: "WhatsApp",
    },
    booking: {
      overline: "Réservation",
      title: "Réservez votre expérience",
      step1: "Expérience",
      step2: "Formule",
      step3: "Invités",
      step4: "Date & heure",
      step5: "Vos coordonnées",
      step6: "Paiement",
      chooseExperience: "Choisissez votre expérience",
      choosePackage: "Choisissez votre formule",
      chooseEvent: "Choisissez votre événement",
      guests: "Nombre d'invités",
      guest: "invité",
      guestsPlural: "invités",
      chooseDate: "Choisissez une date",
      chooseTime: "Choisissez votre horaire",
      available: "Disponible",
      unavailable: "Indisponible",
      booked: "Réservé",
      closed: "Fermé",
      yourDetails: "Vos coordonnées",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      requests: "Demandes spéciales & personnalisation",
      requestsPlaceholder: "Occasion spéciale, préférences alimentaires, décoration, demande en mariage… Dites-nous tout.",
      summary: "Récapitulatif",
      total: "Total",
      payCta: "Confirmer et payer",
      back: "Retour",
      continue: "Continuer",
      paymentNote: "Paiement intégral à la réservation. Cartes bancaires, Apple Pay et Google Pay seront acceptés via notre plateforme sécurisée Stripe.",
      stripePending: "Vous serez redirigé vers notre page de paiement sécurisée Stripe pour finaliser votre réservation. Le paiement intégral confirme immédiatement votre expérience.",
      confirmReservation: "Confirmer ma réservation",
      maxGuests: "Maximum {max} invités pour cette expérience",
      placesLeft: "places restantes",
      perPerson: "par personne",
      loadingSlots: "Chargement des disponibilités…",
      noSlots: "Aucun créneau disponible à cette date.",
      confirmationTitle: "Votre réservation est enregistrée",
      confirmationRef: "Référence",
      confirmationPending: "Paiement en attente",
      confirmationChecking: "Confirmation du paiement en cours…",
      confirmationPaid: "Paiement confirmé",
      confirmationPaidText: "Merci {name} ! Votre paiement est confirmé et votre expérience est officiellement réservée. Vous recevrez très vite l'adresse de votre spot secret par email.",
      confirmationText: "Merci {name} ! Votre expérience est réservée. Vous recevrez très vite un lien de paiement sécurisé pour confirmer définitivement votre moment, puis l'adresse de votre spot secret.",
      confirmationQuestions: "Une question ? Écrivez-nous sur WhatsApp ou par email.",
      bookingError: "Une erreur est survenue. Ce créneau n'est peut-être plus disponible — veuillez réessayer.",
    },
    legal: {
      privacyTitle: "Politique de confidentialité",
      privacyBody: "The Nice Picnic collecte uniquement les informations nécessaires à la gestion de vos réservations (nom, email, téléphone). Ces données ne sont jamais revendues ni partagées avec des tiers à des fins commerciales. Vous pouvez demander l'accès, la modification ou la suppression de vos données à tout moment en écrivant à hello@thenicepicnic.com.",
      termsTitle: "Conditions générales",
      termsBody: "Toute réservation est confirmée après paiement intégral. En cas de météo défavorable, un report est proposé. Les annulations sont possibles jusqu'à 72 heures avant l'expérience. Les spots secrets sont communiqués après confirmation de la réservation.",
      cookiesTitle: "Cookies",
      cookiesBody: "Ce site utilise uniquement les cookies strictement nécessaires à son fonctionnement (préférence de langue, panier de réservation). Aucun cookie publicitaire ou de suivi tiers n'est utilisé.",
    },
    common: {
      from: "À partir de",
      perPerson: "par personne",
      learnMore: "En savoir plus",
      required: "Champ requis",
    },
  },
  en: {
    nav: {
      experiences: "Experiences",
      boho: "The Boho Picnic",
      floating: "Floating Picnic",
      electronic: "Picnic Electronic",
      privateEvents: "Private Events",
      gallery: "Gallery",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      book: "Book now",
    },
    hero: {
      overline: "Nice — Côte d'Azur",
      title: "Exceptional Picnics on the French Riviera",
      subtitle: "Curated picnic experiences, secret spots and unforgettable moments between Nice and the Mediterranean.",
      ctaBook: "Book your picnic",
      ctaDiscover: "Discover our experiences",
    },
    intro: {
      overline: "The Nice Picnic",
      title: "More than a picnic. It's a moment to remember.",
      p1: "The Nice Picnic creates exceptional moments on the French Riviera: a table set by the water, carefully chosen Niçoise specialties, bohemian decoration, music and secret locations selected for their beauty.",
      p2: "Every experience is personalised to your wishes — a birthday, a marriage proposal, a sunset for two or a celebration with friends.",
      signature: "The Nice Picnic — Côte d'Azur",
    },
    experiences: {
      overline: "Our experiences",
      title: "Three ways to live the Riviera",
      from: "From",
      perPerson: "per person",
      discover: "Discover",
      seeEvents: "See events",
      bohoTag: "The signature experience",
      bohoDesc: "A chic bohemian picnic set up in a secret spot: rugs, cushions, jute garlands, Niçoise specialties and wine, facing the Mediterranean.",
      floatingTag: "On the water",
      floatingDesc: "A floating picnic 50 metres from the shore at Port de la Darse, Villefranche-sur-Mer. Swimming, snorkelling, wine and sunshine.",
      electronicTag: "Sunset events",
      electronicDesc: "A premium collective picnic: an organic & deep house DJ set in a secret spot on the French Riviera, timed with the sunset.",
      onRequest: "Dates & pricing per event",
    },
    riviera: {
      overline: "Our secret spots",
      title: "From Nice to the French Riviera",
      p1: "From hidden coves to the hills above the Baie des Anges, we hand-pick secret locations between Nice and the Côte d'Azur for every experience.",
      p2: "The exact address of your spot is revealed after your booking — it's part of what makes each moment unique.",
    },
    lifestyle: {
      overline: "The art of living",
      title: "The Mediterranean, on the table",
      p: "Local Niçoise produce, bohemian styling composed with care, the golden light of the Riviera — every detail tells a story.",
    },
    private: {
      overline: "Bespoke",
      title: "Your private events",
      p: "Birthdays, marriage proposals, romantic moments, private celebrations, corporate events or fully bespoke experiences — we create the moment that looks like you.",
      cta: "Create your experience",
      categories: ["Birthday", "Marriage proposal", "Romantic moment", "Private celebration", "Corporate event", "Bespoke"],
    },
    testimonials: {
      overline: "They lived the experience",
      title: "Memories that stay",
    },
    instagram: {
      overline: "@the.nicepicnic",
      title: "Follow the experience",
      cta: "Follow on Instagram",
    },
    finalCta: {
      title: "Your moment. Your way.",
      cta: "Book your picnic",
    },
    footer: {
      tagline: "Exceptional picnics — Nice, Côte d'Azur",
      navigation: "Navigation",
      contact: "Contact",
      follow: "Follow us",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      cookies: "Cookies",
      rights: "© 2026 The Nice Picnic — Côte d'Azur. All rights reserved.",
    },
    boho: {
      overline: "2 hours — Secret spots between Nice and the Côte d'Azur",
      title: "The Boho Picnic",
      intro: "Our signature experience. A chic bohemian setup prepared for you in a secret location: rugs, cushions, jute garlands, dreamcatchers and a generous table of Niçoise specialties, facing the Mediterranean.",
      packages: "Our packages",
      medium: "Medium Package",
      premium: "Premium Package",
      perPerson: "per person",
      duration: "Duration: 2 hours",
      times: "Booking times",
      timesNote: "Departures at 11:00, 12:00, 13:00, 18:00 and 19:00 — every day, subject to availability.",
      mediumIncludes: ["Floor picnic setup", "Rugs & cushions", "Bohemian decoration", "Jute garlands", "Dreamcatcher-style decoration", "Bluetooth speaker", "Niçoise specialties", "One bottle of wine per two guests", "Still & sparkling water"],
      premiumIncludes: ["Everything in the Medium package", "More elaborate premium decoration", "Moroccan lanterns & additional decorative elements", "More refined styling", "Mini photo printer", "Bluetooth speaker"],
      bookCta: "Book The Boho Picnic",
      makeItYours: "Make it yours.",
      customP: "Every Boho Picnic can be personalised to your wishes: food, decoration, location, special occasion or any other detail. Tell us what you imagine — we create it.",
      customItems: ["Food & dietary preferences", "Decoration & atmosphere", "Location", "Special occasions", "Any other detail"],
      customCta: "Send a customisation request",
      formTitle: "Personalise your picnic",
    },
    floating: {
      overline: "1h30 — Port de la Darse, Villefranche-sur-Mer",
      title: "Floating Picnic",
      intro: "A unique experience on the water: your picnic is set on a floating structure about 50 metres from the shore, in the sheltered Port de la Darse. Stay on board, dive in, swim — the Mediterranean is yours.",
      priceNote: "€89 per person — maximum 2 guests per booking.",
      exclusiveNote: "Only one booking per time slot: the experience is entirely private.",
      slotsTitle: "Daily time slots",
      includesTitle: "The experience includes",
      includes: ["Complete picnic setup", "Niçoise specialties", "Wine", "Still & sparkling water", "Bluetooth speaker", "Hats", "Sunscreen", "Masks & snorkels", "Swimming & water experience"],
      bookCta: "Book the Floating Picnic",
    },
    electronic: {
      overline: "Events — Secret spots on the Côte d'Azur",
      title: "Picnic Electronic",
      intro: "A premium collective picnic at sunset. Bohemian setup, secret spot, organic & deep house DJ set and an immersive atmosphere facing the Mediterranean.",
      upcoming: "Upcoming events",
      places: "places",
      placesLeft: "places left",
      soldOut: "Sold out",
      bookSpot: "Book your spot",
      bookingClosed: "Booking closed",
      empty: "New dates are coming soon. Follow @the.nicepicnic to be the first to know.",
      from: "from",
    },
    privatePage: {
      overline: "Private events",
      title: "Let's create the moment that looks like you",
      intro: "A marriage proposal at sunset, a birthday with your feet in the sand, a confidential corporate event — tell us about your project and we will compose the experience.",
      formTitle: "Tell us about your project",
      name: "Name",
      email: "Email",
      phone: "Phone",
      date: "Preferred date",
      guests: "Number of guests",
      eventType: "Type of event",
      location: "Desired location",
      budget: "Budget",
      food: "Food preferences",
      decoration: "Decoration preferences",
      message: "Your message",
      submit: "Create your experience",
      success: "Thank you! Your enquiry has been sent. We will get back to you very soon.",
      types: ["Birthday", "Proposal", "Romantic experience", "Private celebration", "Corporate event", "Influencer / brand event", "Bespoke"],
    },
    gallery: {
      overline: "Gallery",
      title: "The experience in pictures",
    },
    about: {
      overline: "About",
      title: "The Nice Picnic, Côte d'Azur",
      p1: "Born in Nice, The Nice Picnic is a house of experiences dedicated to the art of the picnic on the French Riviera. We believe a meal can become a memory — when the place, the light, the table and the details are composed together.",
      p2: "Our team hand-picks secret spots between Nice and the Mediterranean, creates bohemian settings from natural materials, and works with the finest artisans of the Niçoise terroir.",
      p3: "Every experience is unique, every detail is personalisable. That is our definition of luxury: a moment that belongs to you alone.",
      values: ["Hand-picked secret locations", "Niçoise terroir produce", "Artisanal bohemian styling", "Complete personalisation"],
    },
    faq: {
      overline: "Frequently asked questions",
      title: "Everything about our experiences",
      items: [
        { q: "Where do the picnics take place?", a: "In hand-picked secret spots between Nice and the Côte d'Azur. The exact address is shared with you once your booking is confirmed." },
        { q: "How does payment work?", a: "Bookings are paid in full online by credit or debit card, Apple Pay or Google Pay through our secure payment platform." },
        { q: "Can I personalise my experience?", a: "Absolutely. Food, decoration, location, special occasion — every detail can be tailored to your wishes. Share your ideas when booking or contact us directly." },
        { q: "What happens in case of bad weather?", a: "If the weather is unfavourable, we will offer to reschedule your experience to a later date." },
        { q: "How many people can join?", a: "The Boho Picnic welcomes groups of all sizes. The Floating Picnic is a private experience for a maximum of 2 guests. Picnic Electronic is a collective event with a limited number of places." },
        { q: "Do you offer vegetarian or gluten-free options?", a: "Yes. Simply let us know your preferences and dietary requirements when booking — our menus are adapted with the same care." },
        { q: "Can I gift an experience?", a: "Contact us on WhatsApp or through the contact form and we will prepare an elegant gift card for your chosen experience." },
        { q: "Do you organise private events?", a: "Yes: birthdays, marriage proposals, celebrations and corporate events. Head to the Private Events page to tell us about your project." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your moment",
      p: "A question, a specific wish, a bespoke project? Write to us — we reply very quickly.",
      formName: "Name",
      formEmail: "Email",
      formMessage: "Message",
      send: "Send",
      success: "Message sent! We will reply very soon.",
      whatsapp: "WhatsApp",
    },
    booking: {
      overline: "Booking",
      title: "Book your experience",
      step1: "Experience",
      step2: "Package",
      step3: "Guests",
      step4: "Date & time",
      step5: "Your details",
      step6: "Payment",
      chooseExperience: "Choose your experience",
      choosePackage: "Choose your package",
      chooseEvent: "Choose your event",
      guests: "Number of guests",
      guest: "guest",
      guestsPlural: "guests",
      chooseDate: "Choose a date",
      chooseTime: "Choose your time",
      available: "Available",
      unavailable: "Unavailable",
      booked: "Booked",
      closed: "Closed",
      yourDetails: "Your details",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      requests: "Special requests & personalisation",
      requestsPlaceholder: "Special occasion, dietary preferences, decoration, marriage proposal… Tell us everything.",
      summary: "Summary",
      total: "Total",
      payCta: "Confirm and pay",
      back: "Back",
      continue: "Continue",
      paymentNote: "Full payment at booking. Credit & debit cards, Apple Pay and Google Pay will be accepted through our secure Stripe platform.",
      stripePending: "You will be redirected to our secure Stripe checkout to complete your booking. Full payment confirms your experience instantly.",
      confirmReservation: "Confirm my reservation",
      maxGuests: "Maximum {max} guests for this experience",
      placesLeft: "places left",
      perPerson: "per person",
      loadingSlots: "Loading availability…",
      noSlots: "No time slots available on this date.",
      confirmationTitle: "Your reservation is recorded",
      confirmationRef: "Reference",
      confirmationPending: "Payment pending",
      confirmationChecking: "Confirming your payment…",
      confirmationPaid: "Payment confirmed",
      confirmationPaidText: "Thank you {name}! Your payment is confirmed and your experience is officially booked. You will receive the address of your secret spot by email very soon.",
      confirmationText: "Thank you {name}! Your experience is reserved. You will shortly receive a secure payment link to definitively confirm your moment, followed by the address of your secret spot.",
      confirmationQuestions: "Any questions? Reach us on WhatsApp or by email.",
      bookingError: "Something went wrong. This slot may no longer be available — please try again.",
    },
    legal: {
      privacyTitle: "Privacy Policy",
      privacyBody: "The Nice Picnic only collects the information required to manage your bookings (name, email, phone). This data is never sold or shared with third parties for commercial purposes. You may request access to, modification of, or deletion of your data at any time by writing to hello@thenicepicnic.com.",
      termsTitle: "Terms & Conditions",
      termsBody: "All bookings are confirmed upon full payment. In case of unsuitable weather, rescheduling is offered. Cancellations are possible up to 72 hours before the experience. Secret spot addresses are shared after booking confirmation.",
      cookiesTitle: "Cookies",
      cookiesBody: "This site only uses cookies that are strictly necessary for its operation (language preference, booking flow). No advertising or third-party tracking cookies are used.",
    },
    common: {
      from: "From",
      perPerson: "per person",
      learnMore: "Learn more",
      required: "Required field",
    },
  },
};
